import whatInput from 'what-input';

export const isKeyboard = () => whatInput.ask() === 'keyboard';
